import { render, staticRenderFns } from "./device-page.vue?vue&type=template&id=0023097a"
import script from "./device-page.vue?vue&type=script&lang=js"
export * from "./device-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0023097a')) {
      api.createRecord('0023097a', component.options)
    } else {
      api.reload('0023097a', component.options)
    }
    module.hot.accept("./device-page.vue?vue&type=template&id=0023097a", function () {
      api.rerender('0023097a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Devices/device-page.vue"
export default component.exports